// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"bb5b71e7","289":"465105fc","323":"937324bd","453":"8352d130","485":"e0008011","504":"2a5dbaf9","639":"6d34e685","942":"2f951c7c","965":"c1eacf2e"}[chunkId] + ".chunk.js";
};